import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GENERATE_COIN_LISTING } from "../../../Types";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const generateCoinListing = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/CoinRepayment/GenerateCoinListing`, requestData)
    .then(({ data }) => {
      dispatch({
        type: GENERATE_COIN_LISTING,
        payload: data,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const recordCoinRepaymentDetail = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/CoinRepayment/RecordCoinRepaymentDetails`, requestData)
    .then(({ data }) => {
      dispatch(hideLoading());
      toast.success("Coin Disbursement successfully");
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const rejectCoinRepaymentDetail = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/CoinRepayment/RejectCoinRepaymentDetails`, requestData)
    .then(({ data }) => {
      dispatch(hideLoading());
      toast.success("Coin Reject successfully");
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/CoinRepayment/GenerateCoinListingExport`, requestData)
    .then(({ data }) => {
      const outputFilename = `Coin_Repayment_Listing${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            //debugger;
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "vizId"
                ? "VizId"
                : ws[address].v == "loanId"
                ? "Loan Id"
                : ws[address].v == "invoiceNumber"
                ? "Invoice #"
                : ws[address].v == "loanDate"
                ? "Loan Date"
                : ws[address].v == "loanAmount"
                ? "Loan Amount"
                : ws[address].v == "paidDate"
                ? "Paid Date"
                : ws[address].v == "paidAmount"
                ? "Paid Amount"
                : ws[address].v == "noOfDays"
                ? "No. Of Days"
                : ws[address].v == "flatFee"
                ? "Flat Fee"
                : ws[address].v == "profit"
                ? "Profit"
                : ws[address].v == "status"
                ? "Status"
                : ws[address].v == "coins"
                ? "No. Of Coins"
                : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data?.report, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
